import React, { Component } from "react";
import { IonSelect, IonSelectOption } from "@ionic/react";

import { Collapse } from "react-collapse";

// CSS
import "../Shared.css";
import "../../App.css";
import "./Dropdown.css";

// Controllers

type Props = {
  dropdownValueChanged: (dropdownValue: string) => void;
  className?: string;
  value: string;
  selectOptions: { label: string; value: string }[];
};
type State = {};

class Dropdown extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
  }

  compareValues(o1: string, o2: string) {
    return o1 === o2;
  }

  updateDropdownValue(event: any) {
    if (this.props.dropdownValueChanged != null) {
      this.props.dropdownValueChanged(event.target.value);
    }
  }

  render() {
    let dropdownSelectOptions = [];

    for (let optionIndex = 0; optionIndex < this.props.selectOptions.length; optionIndex++) {
      let option = this.props.selectOptions[optionIndex];

      dropdownSelectOptions.push(
        <IonSelectOption key={option.label} value={option.value}>
          {option.label}
        </IonSelectOption>
      );
    }

    return (
      <div className={this.props.className}>
        <IonSelect
          className="dropdownContainer"
          interface="popover"
          interfaceOptions={{ cssClass: "temporaryLoginPopover" }}
          mode="ios"
          onIonChange={(event) => this.updateDropdownValue(event)}
          placeholder="All"
          compareWith={this.compareValues}
          value={this.props.value}
        >
          {dropdownSelectOptions}
        </IonSelect>
      </div>
    );
  }
}

export default Dropdown;
